var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "onboarding-building" },
    [
      _c(
        "transition",
        { attrs: { name: "slide-up-md", mode: "out-in", appear: "" } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.unlocked,
                  expression: "unlocked"
                }
              ],
              staticClass: "onboarding-building-figure",
              class: { unlocked: _vm.unlocked }
            },
            [
              _c(
                "svg",
                {
                  staticClass: "hub-editor-loader",
                  attrs: {
                    width: "280",
                    height: "184",
                    viewBox: "0 0 280 184",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("g", { staticClass: "svg-frame" }, [
                    _c("path", {
                      attrs: {
                        d:
                          "M1.207 183.16V9.887a8.673 8.673 0 0 1 2.545-6.141A8.693 8.693 0 0 1 9.9 1.203h259.644a8.705 8.705 0 0 1 6.147 2.543 8.689 8.689 0 0 1 2.545 6.14V183.16",
                        stroke: "#c8e6a1",
                        "stroke-width": "1.5"
                      }
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "8.363",
                        y: "5.821",
                        width: "19.339",
                        height: "9",
                        rx: "4.5",
                        stroke: "#c8e6a1",
                        "stroke-width": "1.5"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        stroke: "#c8e6a1",
                        "stroke-width": "1.5",
                        d: "M1 18.517h277.236"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M41.294 9.413H238.15",
                        stroke: "#c8e6a1",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M257.349 15.073c2.999 0 5.431-2.423 5.431-5.412s-2.432-5.412-5.431-5.412-5.431 2.423-5.431 5.412 2.432 5.412 5.431 5.412Z",
                        stroke: "#c8e6a1",
                        "stroke-width": "1.5"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.svgGroups, function(group, index) {
                    return [
                      _c(
                        "transition",
                        { attrs: { name: "fade-load", mode: "out-in" } },
                        [
                          index == _vm.activeSvg
                            ? _c("g", {
                                staticClass: "svg-group",
                                domProps: { innerHTML: _vm._s(group) }
                              })
                            : _vm._e()
                        ]
                      )
                    ]
                  })
                ],
                2
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "slide-up-md", mode: "out-in", appear: "" } },
        [
          _c(
            "h2",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.unlockedTitle,
                  expression: "unlockedTitle"
                }
              ],
              staticClass: "txt-heading-small mb-0"
            },
            [_vm._v("\n      Creating your first Hub...\n    ")]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }